/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModuleItem_item = {
    readonly title: string | null;
    readonly description: string | null;
    readonly cta: string | null;
    readonly imageUrl: string | null;
    readonly imageHeight: string | null;
    readonly imageWidth: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"HpRespModuleItemTile_linkData">;
    };
    readonly " $refType": "HpRespLocationsModuleItem_item";
};
export type HpRespLocationsModuleItem_item$data = HpRespLocationsModuleItem_item;
export type HpRespLocationsModuleItem_item$key = {
    readonly " $data"?: HpRespLocationsModuleItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModuleItem_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespLocationsModuleItem_item",
  "type": "Product",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageHeight",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageWidth",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "HpRespModuleItemTile_linkData",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'c15f2a9e101f91da40baadfe1829e34e';
export default node;
